import React, { useRef, useState } from 'react';
import { Play, Pause } from 'lucide-react'; // or use react-icons

const VideoPlayer = ({ src, color }) => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const [duration, setDuration] = useState(0);

    const togglePlay = () => {
        const video = videoRef.current;
        if (video.paused) {
            video.play();
            setIsPlaying(true);
        } else {
            video.pause();
            setIsPlaying(false);
        }
    };

    const handleTimeUpdate = () => {
        const video = videoRef.current;
        setProgress((video.currentTime / video.duration) * 100);
    };

    const handleLoadedMetadata = () => {
        setDuration(videoRef.current.duration);
    };

    const formatTime = (secs) => {
        const m = Math.floor(secs / 60);
        const s = Math.floor(secs % 60);
        return `${m}:${s < 10 ? '0' : ''}${s}`;
    };

    return (
        <div className="flex flex-col bg-gray-100 rounded-xl overflow-hidden w-full max-w-sm shadow">
            <video
                ref={videoRef}
                src={src}
                onTimeUpdate={handleTimeUpdate}
                onLoadedMetadata={handleLoadedMetadata}
                onEnded={() => setIsPlaying(false)}
                className="w-full max-h-60"
                controls={false}
            />

            <div className="flex items-center gap-2 px-3 py-2">
                <button onClick={togglePlay}>
                    {isPlaying ? <Pause size={20} style={{ color: "red" }} /> : <Play size={20} style={{ color: "red" }} />}
                </button>

                <input
                    type="range"
                    value={progress}
                    onChange={(e) => {
                        const newProgress = parseFloat(e.target.value);
                        const newTime = (newProgress / 100) * videoRef.current.duration;
                        videoRef.current.currentTime = newTime;
                        setProgress(newProgress);
                    }}
                    className="w-full accent-blue-500 h-1"
                />

                <span className="text-xs text-gray-600 w-12 text-right">
                    {formatTime(duration)}
                </span>
            </div>
        </div>
    );
};

export default VideoPlayer;
